import React, { useState, useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import "./Navbar.css";
import { AuthenticatContext } from '../../context/AuthenticatContext';

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { authentication_data } = useContext(AuthenticatContext);

  // Use the same logic as Login.jsx to check login
  const isLoggedIn =
    authentication_data &&
    authentication_data.authtoken &&
    authentication_data.isLoggedIn;

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="nav-brand">
        <NavLink to="/" className="brand-link">
          <h1>Practcode <span className="brand-ai">Ai</span></h1>
        </NavLink>
      </div>

      {/* Mobile Menu Button */}
      <button className="mobile-menu-btn" onClick={toggleMenu} aria-label="Toggle menu">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          {isMenuOpen ? (
            <path d="M18 6L6 18M6 6l12 12"/>
          ) : (
            <path d="M3 12h18M3 6h18M3 18h18"/>
          )}
        </svg>
      </button>

      {/* Navigation Links */}
      <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
        <NavLink 
          to="/" 
          className={`nav-link ${isActive('/') ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(false)}
        >
          Home
        </NavLink>
        <NavLink 
          to="/courses" 
          className={`nav-link ${isActive('/courses') ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(false)}
        >
          Courses
        </NavLink>
        <NavLink 
          to="/Aptitude-test" 
          className={`nav-link ${isActive('/Aptitude-test') ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(false)}
        >
          Aptitude
        </NavLink>
        <NavLink 
          to="/Codingcompetition/2025/leaderboard" 
          className={`nav-link ${isActive('/Codingcompetition/2025/leaderboard') ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(false)}
        >
          Leaderboard
        </NavLink>
        <NavLink 
          to="/Seven-days-challange" 
          className={`nav-link ${isActive('/Seven-days-challange') ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(false)}
        >
          Seven Days Challenge
        </NavLink>
        {!isLoggedIn && (
          <div className="auth-buttons">
            <NavLink 
              to="/user/login" 
              className={`nav-link ${isActive('/user/login') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Login
            </NavLink>
            <NavLink 
              to="/user/signup" 
              className={`nav-link primary-btn ${isActive('/user/signup') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Sign Up
            </NavLink>
          </div>
        )}
        {isLoggedIn && (
          <div className="profile-icon-btn">
            <NavLink
              to="#"
              className="nav-link profile-link"
              onClick={() => setIsMenuOpen(false)}
              title="Profile"
              style={{ display: 'flex', alignItems: 'center', padding: 0 }}
            >
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 36,
                height: 36,
                borderRadius: '50%',
                background: '#2563eb',
                color: '#fff',
                fontWeight: 700,
                fontSize: 18,
                marginLeft: 12
              }}>
                <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
                  <circle cx="12" cy="8" r="4" stroke="#fff" strokeWidth="2"/>
                  <path d="M4 20c0-3.314 3.134-6 7-6s7 2.686 7 6" stroke="#fff" strokeWidth="2"/>
                </svg>
              </span>
            </NavLink>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;